import { render, staticRenderFns } from "./messagelist.vue?vue&type=template&id=62acf8a2&"
import script from "./messagelist.vue?vue&type=script&lang=ts&"
export * from "./messagelist.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports